angular.module('app').controller('CredentialsPageController',['$rootScope','$scope','$uibModal','$sce','$timeout','$window','$q','tools','modelstore','webservice','errorlog','parameters',
                                            function($rootScope,$scope,$uibModal,$sce,$timeout,$window,$q,tools,modelstore,webservice,errorlog,parameters) {
  var model=$scope.model;
  var script='public/reservationC';

  $scope.salutation={'id':'','shorten':'None','shortnl':'Geen','shortfr':'Aucun','field3':999};

  /*
   * Email domain validation (Tojins/outdoor docs/email-domain-validation.md,
   * Tojins/outdoorpub#1). The rules and the DNS lookup live server-side; this
   * form only renders the two independent signals the server returns and never
   * rewrites the field on its own: a suggestion is applied only when the
   * customer clicks it.
   *
   * A partner can prefill the address and lock the field (emailEditable). A
   * locked address is probed on arrival, since blur never fires on a disabled
   * input, and a definitive "cannot receive mail" verdict unlocks the field so
   * the customer is not stuck behind a rejection they cannot correct.
   */
  var emailDomainValidations={};
  var dismissedSuggestions={};
  $scope.emailDomainSuggestion=null;
  $scope.emailDomainCanReceiveMail=null;

  var currentEmail = function() {
    var email=model.personContact.email;
    return angular.isString(email)?email.trim():'';
  };

  var looksLikeEmail = function(email) {
    return (/^[^@\s]+@[^@\s]+\.[^@\s]+$/).test(email);
  };

  $scope.clearEmailDomainValidation = function() {
    $scope.emailDomainSuggestion=null;
    $scope.emailDomainCanReceiveMail=null;
  };

  var unlockEmail = function() {
    model.personContact.emailEditable=true;
  };

  var focusEmail = function() {
    $timeout(function() {
      var input=$window.document.getElementById('email');
      if(input && angular.isFunction(input.focus)) {
        input.focus();
      }
    });
  };

  var applyEmailDomainValidation = function(email,validation) {
    $scope.clearEmailDomainValidation();
    if(!angular.isObject(validation)) {
      return;
    }
    // null is the resolver failing open: render nothing, block nothing.
    if(validation.canReceiveMail===false) {
      $scope.emailDomainCanReceiveMail=false;
      unlockEmail();
    }
    if(angular.isString(validation.suggestion) && validation.suggestion!=='' && !dismissedSuggestions[email]) {
      $scope.emailDomainSuggestion=validation.suggestion;
    }
  };

  $scope.validateEmailDomain = function() {
    var email=currentEmail();
    $scope.clearEmailDomainValidation();
    if(!looksLikeEmail(email)) {
      return;
    }
    if(email in emailDomainValidations) {
      applyEmailDomainValidation(email,emailDomainValidations[email]);
      return;
    }
    emailDomainValidations[email]=null;
    webservice.silentCall('validateEmailDomain',{'email':email},script,model).then(function(validation) {
      if(!angular.isObject(validation)) {
        delete emailDomainValidations[email];
        return;
      }
      emailDomainValidations[email]=validation;
      if(currentEmail()===email) {
        applyEmailDomainValidation(email,validation);
      }
    },function() {
      delete emailDomainValidations[email];
    });
  };

  $scope.dismissEmailDomainSuggestion = function() {
    dismissedSuggestions[currentEmail()]=true;
    $scope.emailDomainSuggestion=null;
  };

  // The customer's click is the only thing that writes a suggestion into the
  // field. The applied address is probed in turn so it gets its own verdict.
  $scope.applyEmailDomainSuggestion = function() {
    var suggestion=$scope.emailDomainSuggestion;
    if(!angular.isString(suggestion) || suggestion==='') {
      return;
    }
    model.personContact.email=suggestion;
    unlockEmail();
    $scope.validateEmailDomain();
    focusEmail();
  };

  // Runs once the model is loaded (see the loaded chain below): a locked,
  // prefilled address never blurs, so it is probed on arrival. Only on the
  // site, since only the site's save enforces the verdict.
  var validateLockedEmailDomain = function() {
    if($scope.isSiteMode && !model.personContact.emailEditable && looksLikeEmail(currentEmail())) {
      $scope.validateEmailDomain();
    }
  };

  // The version field is the whole backwards-compatibility switch: its
  // presence tells the server to enforce the domain validation on this save.
  // Only the public site opts in; the kiosk has no email field (outdoorpub#1).
  // The submitted address is the trimmed one the blur probe checked, so the
  // server's cache answers the submit.
  var createCredentialsParams = function(voucherCodes) {
    var params=$scope.createReservationParams(voucherCodes,[],{},true);
    if($scope.isSiteMode) {
      params.emailDomainValidationVersion=1;
      for(var i in params.contacts) {
        if(angular.isString(params.contacts[i].email)) {
          params.contacts[i].email=params.contacts[i].email.trim();
        }
      }
    }
    return params;
  };

  // Rejection handler for a versioned save: when the server rejected the email
  // domain, show the rejection inline at the field instead of leaving the
  // customer with a bare toast, and bring the field back into view. The
  // verdict is keyed by the address that was submitted; if the customer has
  // already edited the field meanwhile it is not shown for the new address.
  var submitRejected = function(submittedEmail,askLeavePageBeforeUnload) {
    return function(error) {
      if(angular.isObject(error) && error.code==='email-domain-cannot-receive-mail') {
        $scope.setLeavePageBeforeUnloadTo(askLeavePageBeforeUnload);
        emailDomainValidations[submittedEmail]={'canReceiveMail':error.canReceiveMail,'suggestion':error.suggestion};
        if(currentEmail()===submittedEmail) {
          applyEmailDomainValidation(submittedEmail,emailDomainValidations[submittedEmail]);
          focusEmail();
        }
      }
      return $q.reject(error);
    };
  };

  // Snapshot taken right before a submit, for submitRejected.
  var submitContext = function() {
    return submitRejected(currentEmail(),$scope.askLeavePageBeforeUnload);
  };

  $scope.trustAsHtml = function() {
    $scope.trustLabelsAsHtml('credentials',model.formbuttoncomponents);
  };

  $scope.setPersonContactGsmAndCountry = function() {
    model.personContact.country=parameters.countryCallingCodes[model.personContact.countryCallingKey].countryId;
    if(!($scope.hasVoucher || model.delivery==='1') && model.personContact.country!=='BE') {
      model.personContact.postalcode='';
    }
    model.personContact.gsm=(model.personContact.number==='')?(''):('+'+model.personContact.countryCallingCode+'(0)'+model.personContact.number);
  };

  $scope.initDate = function(yearOffset) {
    var date=new Date();
    date.setFullYear(date.getFullYear()+yearOffset);
    return date;
  };

  $scope.takeawayInfoIsFilled = function() {
    var result;
    if(!$scope.isCatering()) {
      result=$q.resolve();
    } else if(model.delivery===null) {
      errorlog.error(tools.lang({
        'en':'Please select takeaway or delivery',
        'nl':'Gelieve afhaal of levering te selecteren',
        'fr':'Veuillez selectionner venir chercher sur place ou livraison'
      }));
      result=$q.reject();
    } else if(model.startdateISO===tools.today() && model.lastOrderHourPassed) {
      errorlog.error(tools.lang({
        'en':'The ordering is closed for today, last order before ',
        'nl':'De bestellingen voor vandaag zijn afgelopen, de laatste bestelling is om ',
        'fr':'Les commandes sont ferm\u00E9es pour aujourd\u0027hui, la derni\u00E8re commande est possible jusqu\u0027\u00E0 '
      })+tools.label(parameters.HRS[$scope.getMaxHrsDate()]));
      result=$q.reject();
    } else if(model.takeawayHrs===null) {
      errorlog.error(tools.lang({
        'en':'Please select the time',
        'nl':'Gelieve het tijdstip te selecteren',
        'fr':'Veuillez selectionner l\u0027heure'
      }));
      result=$q.reject();
    } else {
      result=$q.resolve();
    }
    return result;
  };

  $scope.startOnlinePaymentProcess = function() {
    if(!$scope.isUndefinedReferer()) {
      $scope.termsAndConditionsAreAccepted().then(function() {
        $scope.takeawayInfoIsFilled().then(function() {
          $scope.openVoucherModal().then(function(promoAndVoucherCodes) {
            if(promoAndVoucherCodes.promoCode!=='') {
              model.campaignCode=promoAndVoucherCodes.promoCode;
            }
            var params = createCredentialsParams(promoAndVoucherCodes.voucherCodes);
            var checkoutItems = [];
            for(var id in params.items) {
              checkoutItems.push(model.items[params.items[id].id]);
            }
            $scope.pushGTMCheckout(checkoutItems);
            var rejected=submitContext();
            $scope.setLeavePageBeforeUnloadTo(false);
            webservice.exclusiveCall('createToPayOnline',$scope.ignoreZeroQuantities(params),script,model).then(function(response) {
              if('formSubmit' in response) {
                $rootScope.$broadcast('onlinepayment.pay',response.formSubmit);
              } else if('voucher' in response) {
                $scope.redirectWhenFinished();
              } else if('redirect' in response) {
                $window.location.href=response.redirect;
              }
            },rejected);
          });
        });
      });
    }
  };

  $scope.createReservation = function() {
    $scope.termsAndConditionsAreAccepted().then(function() {
      var params=createCredentialsParams([]);
      var checkoutItems=[];
      for(var id in params.items) {
        checkoutItems.push(model.items[params.items[id].id]);
      }
      $scope.pushGTMCheckout(checkoutItems);
      var rejected=submitContext();
      $scope.setLeavePageBeforeUnloadTo(false);
      webservice.exclusiveCall('createReservation',$scope.ignoreZeroQuantities(params),script,model).then(function() {
        $scope.redirectWhenFinished();
      },rejected);
    });
  };

  $scope.createReservationWithCreditcard = function() {
    $scope.termsAndConditionsAreAccepted().then(function() {
      var params=createCredentialsParams([]);
      var checkoutItems=[];
      for(var id in params.items) {
        checkoutItems.push(model.items[params.items[id].id]);
      }
      $scope.pushGTMCheckout(checkoutItems);
      var rejected=submitContext();
      $scope.setLeavePageBeforeUnloadTo(false);
      var contactcreditcard=tools.clone(model.contactcreditcard);
      contactcreditcard.contact=params.visit.owningcontact;
      contactcreditcard.expirydate=tools.dateFromJava(new Date(model.contactcreditcard.expiryyear,model.contactcreditcard.expirymonth),0);
      params.contactcreditcards=tools.whitelist([contactcreditcard],['contact','unencryptedCardnumber','unencryptedCvc','expirydate']);
      webservice.exclusiveCall('createReservation',$scope.ignoreZeroQuantities(params),script,model).then(function() {
        $scope.redirectWhenFinished();
      },rejected);
    });
  };

  $scope.getOnlinePrice = function() {
    var price=0.0;
    if(angular.isUndefined(model.campaignPromotion) || model.campaignPromotion===null || !model.campaignOnlyForOnlinePayment) {
      price=$scope.getReservationPrice();
    } else {
      var promotionAmount=parseFloat(model.campaignPromotion.amount);
      var promotionPercent=model.campaignPromotion.percent;
      var promotionPerItem=model.campaignPromotion.peritem;
      var items=$scope.getItems(undefined);
      var itemLength=items.length;
      var i,item,activity,gross,promotionReductionAmount,itemReductionAmount,discountAllowed,itemType;
      for(i=0;i<itemLength;i++) {
        item=items[i];
        itemType=item.itm.substr(0,2);
        discountAllowed=true;
        if(itemType==='HP') {
          discountAllowed=parameters.HPD[item.itm.substr(2,6)].labelen.toLowerCase()!=='city tax';
        } else if(itemType==='PR') {
          discountAllowed=parameters.PRD[item.itm.substr(5,3)].field2==='1';
        }
        gross=item.quantity*item.grossunitprice;
        if(promotionPercent==='1') {
          promotionReductionAmount=Math.round(gross*promotionAmount)/100.0;
        } else {
          promotionReductionAmount=promotionAmount;
        }
        if(item.percent==='1') {
          itemReductionAmount=Math.round(gross*item.reductionamount)/100.0;
        } else {
          itemReductionAmount=item.reductionamount;
        }
        if('participants' in item && promotionReductionAmount>itemReductionAmount) {
          activity=model.activities[model.participants[item.participants[0]].activity];
          if(model.campaignFrmIds.indexOf(activity.frm)>=0 || model.campaignFrmIds.indexOf(activity.frm.substr(0,3)+'***')>=0 || promotionPerItem==='0') {
            price+=gross-promotionReductionAmount;
          } else {
            price+=item.nettopay;
          }
        } else if(promotionPerItem==='0' && discountAllowed) {
          price+=gross-promotionReductionAmount;
        } else {
          price+=item.nettopay;
        }
      }
    }
    return price;
  };

  model.page='credentials';
  $window.scrollTo(0, 0);
  $scope.dateOfBirthOpened=false;
  $scope.dateOfBirthOptions={
    maxDate: $scope.initDate(-12),
    minDate: $scope.initDate(-112),
    startingDay: 1,
    datepickerMode:'year',
    initDate:$scope.initDate(-30)
  };

  $scope.calculatePaymentOptions = function() {
    if($scope.isCatering() || tools.getLength(model.longTermBasket)===0) {
      $scope.payAtLocationIsAvailable=false;
      $scope.debetPaymentIsAvailable=true;
      $scope.reservationWithCreditcardIsAvailable=false;
    } else {
      $scope.payAtLocationIsAvailable=true;
      $scope.debetPaymentIsAvailable=true;
      $scope.reservationWithCreditcardIsAvailable=false;
      var i,j,longTermBasketContent,formbuttoncomponentReference,formbuttoncomponentCategory,act;
      for(i in model.longTermBasket) {
        longTermBasketContent=model.longTermBasket[i];
        for(j in longTermBasketContent) {
          formbuttoncomponentReference=longTermBasketContent[j];
          if(angular.isObject(formbuttoncomponentReference) && (formbuttoncomponentReference.formbuttoncomponent in model.formbuttoncomponents)) {
            formbuttoncomponentCategory=model.formbuttoncomponents[formbuttoncomponentReference.formbuttoncomponent].param1;
            if(formbuttoncomponentCategory==='PR' || formbuttoncomponentCategory==='ME') {
              $scope.payAtLocationIsAvailable=false;
            } else if(formbuttoncomponentCategory==='HS') {
              $scope.payAtLocationIsAvailable=false;
              $scope.reservationWithCreditcardIsAvailable=true;
            } else if(formbuttoncomponentCategory==='AC') {
              act=model.activities[formbuttoncomponentReference.record].frm.substr(0,3);
              if(parameters.ACT[act].field7==='1') {
                $scope.payAtLocationIsAvailable=false;
              }
            }
          }
        }
      }
    }
  };

  $scope.calculateHasVoucher = function() {
    $scope.hasVoucher=false;
    for(var i in model.longTermBasket) {
      $scope.hasVoucher=$scope.basketContainsVoucher(model.longTermBasket[i]);
    }
  };

  $scope.takeawayHrsOptions=[];
  $scope.setTakeawayHrsOptions = function() {
    $scope.takeawayHrsOptions=[];
    if(model.delivery!==null) {
      var allOptions=model.restaurantAvailabilities[model.startdateISO];
      if(model.startdateISO>tools.today()) {
        $scope.takeawayHrsOptions=allOptions;
      } else {
        var delay=model.delivery==='0'?30:45;
        var minHrsDate=new Date();
        minHrsDate.setMinutes(minHrsDate.getMinutes()+delay);
        var minHrs=tools.hourFromJava(minHrsDate);
        model.lastOrderHourPassed=$scope.lastOrderHourPassed('00:00:00');
        if(!model.lastOrderHourPassed) {
          for(var i in allOptions) {
            if(allOptions[i]>=minHrs) {
              $scope.takeawayHrsOptions.push(allOptions[i]);
            }
          }
        }
      }
    }
  };

  $scope.setDelivery = function() {
    for(var i in model.meals) {
      model.meals[i].delivery=model.delivery;
    }
  };

  $scope.setTakeawayHrs = function() {
    for(var i in model.meals) {
      model.meals[i].hrs=model.takeawayHrs;
    }
  };

  $scope.getCreditcardYears = function() {
    var result=[];
    var currentYear=new Date().getFullYear();
    for(var i=0;i<20;i++) {
      result.push(String(currentYear+i));
    }
    return result;
  };

  model.lastOrderHourPassed=$scope.lastOrderHourPassed('00:00:00');
  $scope.calculatePaymentOptions();
  $scope.calculateHasVoucher();
  $scope.trustAsHtml();
  $scope.loaded.then(function() {
    $scope.trustAsHtml();
    $scope.calculateHasVoucher();
    model.delivery=$scope.isDeliverable()?null:'0';
    $scope.setDelivery();
    if(model.delivery!==null && $scope.isCatering()) {
      $scope.setTakeawayHrsOptions();
    }
    $scope.setCurrentStepIndexToMax();
    validateLockedEmailDomain();
  });
  $scope.$on('loaded',function() {
    $scope.calculatePaymentOptions();
    if(model.delivery!==null) {
      $scope.setTakeawayHrsOptions();
    }
    $scope.setCurrentStepIndexToMax();
  });

}]);
